import React, { useEffect } from 'react';
import { Button, Modal, ModalBody, ModalFooter, Form, } from 'reactstrap';
import { round, sumBy, pickBy, pick, get, keyBy, uniq, omit, mapValues, } from 'lodash';
import { useList, } from 'react-use';
import { addDays, } from 'date-fns';
import classnames from 'classnames';

import { integerFormat } from '../../util';
import useFormState from '../hooks/useFormState';
import Field from '../Field';
import { cfMappingItemFields, } from '../../shared/models/consolidationAccountItem';
import ListForm from '../ListForm';

const { entries, } = Object;

export default function CfMappingModal(props) {
  const { isOpen, values, cfChangeTypes, cfAccountItems, customChangeFields, onClickClose, } = props;
  const [items, { set: setItems, updateAt: updateItemAt }] = useList(values.cfMappingItems || []);
  const isUnsubmittable = items.some(_ => !_.isValid);
  const onSubmit = async (event) => {
    event.preventDefault();
    if(isUnsubmittable) return;

    props.onSubmit({ cfMappingItems: items.map(_ => omit(_, 'isValid')), });
  };

  return (
    <Modal isOpen={isOpen} toggle={onClickClose} style={{ minWidth: 1300 }}>
      <div className="modal-header">
        <div className="w-100 d-flex justify-content-between">
          <h5 className="modal-title">
            CFマッピング
          </h5>
        </div>
      </div>
      <Form onSubmit={onSubmit}>
        <ModalBody>
          <div className="mt-3">
            <ListForm
              addButtonLabel="追加"
              items={items}
              renderItem={(item, itemIndex) => {
                return (
                  <div className="card p-3">
                    <ItemForm
                      index={itemIndex}
                      values={item}
                      onChange={_ => updateItemAt(itemIndex, { ...item, ..._, })}
                      {...{ cfChangeTypes, cfAccountItems, customChangeFields, }}
                    />
                  </div>
                );
              }}
              onChange={setItems}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button className="cancel" color="secondary" onClick={onClickClose}>閉じる</Button>
          <Button className="save" type="submit" color="primary" onClick={onSubmit} disabled={isUnsubmittable}>保存</Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

function ItemForm (props) {
  const { values, onChange, cfChangeTypes, cfAccountItems, customChangeFields, } = props;
  const statedFields = useFormState(values, cfMappingItemFields({ cfChangeTypes, cfAccountItems, customChangeFields, }), values);
  useEffect(() => {
    onChange({
      ...mapValues(statedFields, 'value'),
      isValid: Object.values(statedFields).every(_ => _.isValid),
    });
  }, [...Object.values(statedFields).map(_ => _.value)]);

  return (
    <div>
      <div className="d-flex">
        {
          entries(statedFields).map(([fieldName, fieldSetting]) => (
            <div key={fieldName} className="mr-2" style={{ minWidth: 250 }}>
              <Field
                key={fieldName}
                name={fieldName}
                {...fieldSetting}
                values={mapValues(statedFields, 'value')}
                label={false}
              />
            </div>
          ))
        }
      </div>
    </div>
  );
}
